import {PropsWithChildren} from "react";
import {useLocation, useNavigate} from "react-router";

import Button from "@/components/button/Button.tsx";
import {ButtonSize, ButtonTypography, ButtonVariant} from "@/components/button/Button.types.ts";
import {IncidentType} from "@/lib/types/statuspages.ts";

export interface IncidentEditActionProps extends PropsWithChildren {
  variant?: ButtonVariant;
  size?: ButtonSize;
  typography?: ButtonTypography;
  className?: string;
  incidentId: number;
  incidentType: IncidentType;
}

export const IncidentEditAction = ({
  variant,
  size,
  className,
  typography,
  incidentId,
  children,
}: IncidentEditActionProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = () => {
    const params = new URLSearchParams();
    params.set("redirectTo", location.pathname + location.search);

    navigate(`/incidents/${incidentId}/edit?${params.toString()}`);
  };

  return (
    <Button variant={variant} size={size} typography={typography} className={className} onClick={handleClick}>
      {children}
    </Button>
  );
};
